import Splide from '@splidejs/splide';

const EL = '.js-reference-carousel';

document.querySelectorAll('.js-reference-carousel').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'loop',
    arrows: false,
    rewind: true,
    pagination: true,
    gap: 130,
    fixedWidth: '550px',
    focus: 'center',
    breakpoints: {
      1024: {
        fixedWidth: '450px',
        gap: 80,
      },
      767: {
        fixedWidth: '90%',
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }
});
